import React from 'react';
import './ZafiroLogo.css';

export const ZafiroLogo: React.FC<{ className?: string }> = ({ className = "" }) => (
    <div className={`zafiro-logo ${className}`}>
        <div className="logo-icon">
            <svg viewBox="0 0 900 900" xmlns="http://www.w3.org/2000/svg">
                {/* Definición de gradientes 
                <defs>
                    <linearGradient id="Degradado_sin_nombre_6" x1="515.1" y1="546.8" x2="631.6" y2="642.2" gradientTransform="translate(0 902) scale(1 -1)" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stopColor="#006867" />
                        <stop offset="0" stopColor="#086d6c" stopOpacity=".9" />
                        <stop offset=".2" stopColor="#1f7b7a" stopOpacity=".9" />
                        <stop offset=".4" stopColor="#459190" stopOpacity=".8" />
                        <stop offset=".6" stopColor="#79b0af" stopOpacity=".6" />
                        <stop offset=".8" stopColor="#bbd7d6" stopOpacity=".5" />
                        <stop offset="1" stopColor="#fff" stopOpacity=".4" />
                    </linearGradient>
                    <linearGradient id="Degradado_sin_nombre_5" x1="488.8" y1="252" x2="676.6" y2="405.9" gradientTransform="translate(0 902) scale(1 -1)" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stopColor="#006867" stopOpacity=".7" />
                        <stop offset="0" stopColor="#086d6c" stopOpacity=".7" />
                        <stop offset=".2" stopColor="#1f7b7a" stopOpacity=".6" />
                        <stop offset=".4" stopColor="#459190" stopOpacity=".5" />
                        <stop offset=".6" stopColor="#79b0af" stopOpacity=".4" />
                        <stop offset=".8" stopColor="#bbd7d6" stopOpacity=".3" />
                        <stop offset="1" stopColor="#fff" stopOpacity=".2" />
                    </linearGradient>
                    <linearGradient id="Degradado_sin_nombre_3" x1="569.3" y1="260.1" x2="562.8" y2="15" gradientTransform="translate(0 902) scale(1 -1)" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stopColor="#fff" stopOpacity=".2" />
                        <stop offset="0" stopColor="#fcfdfd" stopOpacity=".2" />
                        <stop offset=".1" stopColor="#c2dbda" stopOpacity=".3" />
                        <stop offset=".2" stopColor="#8ebcbc" stopOpacity=".4" />
                        <stop offset=".4" stopColor="#62a2a2" stopOpacity=".5" />
                        <stop offset=".5" stopColor="#3f8d8c" stopOpacity=".6" />
                        <stop offset=".6" stopColor="#237d7c" stopOpacity=".7" />
                        <stop offset=".7" stopColor="#107170" stopOpacity=".8" />
                        <stop offset=".9" stopColor="#046a69" stopOpacity=".9" />
                        <stop offset="1" stopColor="#006867" />
                    </linearGradient>
                    <linearGradient id="Degradado_sin_nombre_4" x1="-406.5" y1="1442" x2="-218.6" y2="1596" gradientTransform="translate(91 -742.5) rotate(-180) scale(1 -1)" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stopColor="#fff" stopOpacity=".2" />
                        <stop offset="0" stopColor="#f3f8f8" stopOpacity=".2" />
                        <stop offset="0" stopColor="#c1dada" stopOpacity=".3" />
                        <stop offset=".2" stopColor="#93bfbe" stopOpacity=".3" />
                        <stop offset=".3" stopColor="#6ba8a7" stopOpacity=".4" />
                        <stop offset=".3" stopColor="#4a9493" stopOpacity=".5" />
                        <stop offset=".4" stopColor="#2f8483" stopOpacity=".5" />
                        <stop offset=".5" stopColor="#1a7777" stopOpacity=".6" />
                        <stop offset=".7" stopColor="#0b6f6e" stopOpacity=".7" />
                        <stop offset=".8" stopColor="#036a69" stopOpacity=".8" />
                        <stop offset="1" stopColor="#006867" />
                    </linearGradient>
                    <linearGradient id="Degradado_sin_nombre_5-2" x1="-284.4" y1="252" x2="-96.6" y2="405.9" gradientTransform="translate(126.8 902) rotate(-180)" xlinkHref="#Degradado_sin_nombre_5" />
                    <linearGradient id="Degradado_sin_nombre_6-2" x1="-468.2" y1="788" x2="-187.8" y2="1017.7" gradientTransform="translate(565.3 -661.8) rotate(-146.5) scale(1 -1)" xlinkHref="#Degradado_sin_nombre_6" />
                </defs>
                */}
                <g>
                    <polygon fill="#005e58" points="763.2 553.4 450 553.4 450 244.6 763.2 553.4" />
                    <polygon fill="#005155" points="763.2 553.4 539.8 644.3 450 553.4 763.2 553.4" />
                    <polygon fill="#006867" points="763.2 553.4 450 244.6 450 7 763.2 553.4" />
                    <polygon fill="#00605f" points="450 7 450 244.6 136.8 553.4 450 7" />
                    <polygon fill="#006867" points="450 244.6 450 553.4 136.8 553.4 450 244.6" />
                    <polygon fill="#006867" points="350.3 646.5 209.1 780.1 136.8 553.4 350.3 646.5" />
                    <polygon fill="#005155" points="450 690.3 450 894 209.1 780.1 450 690.3" />
                    <polygon fill="#00605f" points="450 553.4 450 553.4 350.3 646.5 136.8 553.4 450 553.4" />
                    <polygon fill="#00464e" points="683.2 792.2 450 894 450 690.3 683.2 792.2" />
                    <polygon fill="#006867" points="683.2 792.2 450 690.3 450 690.3 539.8 644.3 683.2 792.2" />
                    <polygon fill="#00605f" points="763.2 553.4 683.2 792.2 539.8 644.3 763.2 553.4" />
                    <polygon fill="#00605f" points="539.8 644.3 450 690.3 450 553.4 450 553.4 539.8 644.3" />
                    <polygon fill="#005155" points="450 553.4 450 681.6 450 690.3 350.3 646.5 450 553.4" />
                    <polygon fill="#01454e" points="450 690.3 209.1 780.1 350.3 646.5 450 690.3" />
                    {/*
                    <polygon fill="url(#Degradado_sin_nombre_6)" points="450 7 450 244.6 763.2 553.4 450 7" />
                    <polygon fill="url(#Degradado_sin_nombre_5)" points="450 553.4 539.8 644.3 763.2 553.4 450 553.4" />
                    <polygon fill="url(#Degradado_sin_nombre_3)" points="450 690.3 450 894 683.2 792.2 450 690.3" />
                    <polygon fill="url(#Degradado_sin_nombre_4)" points="450 894 450 690.3 209.1 780.1 450 894" />
                    <polygon fill="url(#Degradado_sin_nombre_5-2)" points="450 553.4 350.3 646.5 136.8 553.4 450 553.4" />
                    <polygon fill="url(#Degradado_sin_nombre_6-2)" points="141.2 546.9 450 244.6 450 7 141.2 546.9" />
                    */}
                </g>
            </svg>
        </div>
        <span className="logo-text">ZAFIRO</span>
    </div>
);





/*

import React from 'react';
import './ZafiroLogo.css';

export const ZafiroLogo: React.FC<{ className?: string }> = ({ className = "" }) => (
    <div className={`zafiro-logo ${className}`}>
        <div className="logo-icon">
            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">

                <polygon points="16,2 7,15 25,15" fill="#3A9B92" />
                <polygon points="7,15 5,21 12,21 14,17" fill="#2E8179" />
                <polygon points="25,15 27,21 20,21 18,17" fill="#348882" />
                <polygon points="14,17 12,21 16,23 20,21 18,17" fill="#2A7972" />
                <polygon points="7,15 14,17 16,13" fill="#2F847C" />
                <polygon points="25,15 18,17 16,13" fill="#358985" />
                <polygon points="5,21 9,27 12,21" fill="#1C5D56" />
                <polygon points="12,21 16,23 13,28" fill="#18534C" />
                <polygon points="9,27 13,28 16,30" fill="#0F3D38" />
                <polygon points="27,21 23,27 20,21" fill="#206159" />
                <polygon points="20,21 16,23 19,28" fill="#1B5751" />
                <polygon points="23,27 19,28 16,30" fill="#12403B" />
                <polygon points="13,28 16,30 19,28 16,26" fill="#0D3632" />
            </svg>
        </div>
        <span className="logo-text">ZAFIRO</span>
    </div>
);

*/